import React from 'react';
import { CellType, replaceall, isEmpty, stickynote, stickymark, stickycolor } from '../modules/appLibrary';
import Chip from '@material-ui/core/Chip';
import { makeStyles } from '@material-ui/core/styles';
import Icon from '@material-ui/core/Icon';
import IconButton from '@material-ui/core/IconButton';
import Box from '@mui/material/Box';
import noimage from '../Resources/noimg.jpg';
import addimage from '../Resources/addimg.png';

const useStyles = makeStyles((theme) => ({
    chip: {
        margin: theme.spacing(0.2),
    },
}));

//--------------------------------------------------------
//  TagRender
//--------------------------------------------------------
export default function RenderTag(props) {
    const cellValue = props.valueFormatted ? props.valueFormatted : props.value;
    const classes = useStyles();
    const CELLTYPE = CellType();

    //TAG Delete
    function handleDelete(deletetag) {
        const tags = replaceall(cellValue, "　", " ").split(' ');
        const newtags = tags.filter(function (tag) {
            return tag !== deletetag;
        });
        props.deletetag(props, newtags.join(' '), deletetag);
    };
    function ButtonClick(e) {
        props.clicked(props);
    }
    function Imageclick(mode, src) {
        props.imageclick(props, mode, src);
    }

    function editag() {
        if (!isEmpty(props.edittag)) {
            //SearchListでmytagの場合
            return props.edittag(props.colDef.colId);
        }
        return editable();
    }
    function editable() {
        if (typeof props.colDef.editable === 'function') {
            return props.colDef.editable(props);
        } else {
            return props.colDef.editable;
        }
    }
    function TagRender(param) {
        if (isEmpty(cellValue)) return '';
        const tags = replaceall(cellValue, "　", " ").split(' ');
        return tags.map(
            (tag) =>
                <Chip
                    size="small"
                    variant="outlined"
                    color="primary"
                    style={{ color: "#333", height: 20 }}
                    label={tag}
                    onDelete={!editag() ? undefined : () => handleDelete(tag)}
                    className={classes.chip} />
        );
    }
    function RenderTag(param) {
        if (props.colDef.colinfo.datatype !== CELLTYPE.TAG) return null;
        return <div style={{ position: 'rerative' }}>
            <TagRender />
            {!editable() ? null :
                <div style={{ position: 'absolute', top: 0, right: 0, cursor: 'pointer' }} onClick={ButtonClick}>
                    <IconButton size="small">
                        <Icon>arrow_right</Icon>
                    </IconButton>
                </div>
            }
        </div>
    }

    function RenderStickey(param) {
        if (props.colDef.colinfo.datatype !== CELLTYPE.STICKY) return null;
        if (isEmpty(props.data)) return null;
        let data = props.data[props.colDef.colId];
        let Value = stickynote(data);
        let mark = stickymark(data);
        let color = stickycolor(data);
        let title = mark.length !== 0 ? mark + "/" + color : "";
        return <div title={title}>
            <IconButton size="small" onClick={editable() ? ButtonClick : null}>
                {mark === undefined || mark === '' ?
                    <Icon style={{ color: 'white' }}>arrow_right</Icon> :
                    <Icon style={{ color: color }}>{mark}</Icon>
                }
            </IconButton>
            {Value}
        </div>
    }
    function RenderColor(param) {
        //Viewのみ
        if (props.colDef.colinfo.datatype !== CELLTYPE.COLOR) return null;
        return <div style={{ position: 'rerative' }}>
            {isEmpty(cellValue) ? null :
                <Box
                    sx={{
                        mt: 0.5, width: 20, height: 20,
                        backgroundColor: cellValue
                    }}
                />
            }
            <div style={{ position: 'absolute', top: 0, left: 38 }}>
                {cellValue}
            </div>
        </div>
    }
    function RenderImage(param) {
        //Viewのみ
        if (props.colDef.colinfo.datatype !== CELLTYPE.IMAGE) return null;
        var mode = 0;
        var imagevalue = cellValue;
        if (imagevalue === '') {
            imagevalue = noimage; mode = 1;
        }
        else {
            if (isEmpty(imagevalue)) {
                imagevalue = addimage; mode = 2;    //未読み込み
            }
        }
        return (
            <img
                src={imagevalue}
                alt=""
                title={mode===2?'画像追加読み込み' : ''}
                onClick={()=>Imageclick(mode, imagevalue)}
                style={{
                    width: mode===2 ? '24px':'50px',
                    height: mode === 2 ? '24px' : '50px',
                    objectFit: 'cover',
                    cursor: 'pointer'
                }}
            />
        );
    }

    return (
        <React.Fragment>
            <RenderStickey />
            <RenderTag />
            <RenderColor />
            <RenderImage />
        </React.Fragment>
    );
}
